import { useState, useEffect } from "react";
import { Input } from "@rumbledirect/ui";
import { Form, Badge, FormProps } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { ServicepartnerFilterValues } from "../lib/types/ServicepartnerFilterValues.interface";
import { Modal } from "@/components/v2";
import { Button, Card, CardFooter } from "@rumbledirect/ui";
import { servicepartnerFilterFields } from "../lib/constants/servicepartnerFilterFields";
import { buildCompleteFilterForm } from "@/lib/helpers/buildCompleteFilterForm";

interface ServicepartnerFilterModalProps {
  setServicepartnerFilters: (filterValues: ServicepartnerFilterValues) => void;
  servicepartnerFilters?: ServicepartnerFilterValues;
}

export const ServicepartnerFilterModal = ({
  setServicepartnerFilters,
  servicepartnerFilters = {},
}: ServicepartnerFilterModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  // Count active filters
  const activeFiltersCount = Object.values(servicepartnerFilters).length;

  useEffect(() => {
    // Write every known field so cleared filters are reset rather than merged.
    form.setFieldsValue(
      buildCompleteFilterForm(
        servicepartnerFilterFields,
        servicepartnerFilters,
      ),
    );
  }, [servicepartnerFilters, form]);

  const handleSubmit: FormProps<ServicepartnerFilterValues>["onFinish"] = (
    values,
  ) => {
    // Filter out empty values
    const filteredValues: ServicepartnerFilterValues = Object.fromEntries(
      Object.entries(values).filter(
        ([, value]) => value != null && value !== "",
      ),
    );

    setServicepartnerFilters(filteredValues);
    setIsModalOpen(false);
  };

  const handleReset = () => {
    form.resetFields();
    setServicepartnerFilters({});
    setIsModalOpen(false);
  };

  return (
    <>
      <Badge count={activeFiltersCount}>
        <Button
          icon={<FilterOutlined />}
          onClick={() => setIsModalOpen(true)}
          variant="light"
        >
          Filters
        </Button>
      </Badge>

      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)}>
        <Card title="Servicepartner filters">
          <p style={{ marginBottom: 24, color: "#666" }}>
            Filter de herstellers op basis van de onderstaande criteria.
          </p>

          <Form
            form={form}
            layout="vertical"
            initialValues={servicepartnerFilters}
            onFinish={handleSubmit}
          >
            {servicepartnerFilterFields.map((field) => {
              return (
                <Form.Item
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  rules={field.rules}
                >
                  <Input placeholder={field.placeholder} allowClear />
                </Form.Item>
              );
            })}

            <CardFooter>
              <Button onClick={() => setIsModalOpen(false)}>Annuleren</Button>

              <Button onClick={handleReset} className="ml-auto">
                Filters wissen
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
              >
                Filter toepassen
              </Button>
            </CardFooter>
          </Form>
        </Card>
      </Modal>
    </>
  );
};
